import {
  Color,
  Scene,
  WebGLRenderer,
} from 'three';

import { ScatterCamera } from './ScatterCamera';

const farClip = 5000;
const nearClip = 0.1;

export const scene = new Scene();
scene.background = new Color("rgb(225, 225, 225)");

export const camera = new ScatterCamera(
  25,
  window.innerWidth / window.innerHeight,
  nearClip,
  farClip,
);
scene.add(camera);

export const renderer = new WebGLRenderer({ antialias: true });
export const domElementId = 'threejs-canvas';
renderer.domElement.id = domElementId;

function setSize(){
  renderer.setPixelRatio(window.devicePixelRatio);
  renderer.setSize(window.innerWidth, window.innerHeight);

  camera.aspect = window.innerWidth / window.innerHeight;
  camera.updateProjectionMatrix();
}

window.addEventListener('resize', setSize);
setSize();

document.body.appendChild(renderer.domElement);
